import React from 'react';

// Who is allowed to open a user's detail page. Mirrors the requireRole list on
// GET /api/users/:id -- if the two drift, people get links that 403, so treat
// this as one rule expressed in two places rather than two rules.
//
// Staff and custodians are excluded on purpose: a teacher has no business
// browsing a colleague's ticket history.
export const canViewUserPages = (viewer) =>
  !!viewer && ['admin', 'tech', 'tech-admin', 'facilities', 'facilities-admin'].includes(viewer.role);

// A person's name, as a link where that's permitted and plain text where it
// isn't. Renders the fallback when there's no id to link to -- names coming
// from the audit trail can outlive the account they refer to, and 'Unassigned'
// is a label rather than a person.
const UserLink = ({ id, name, viewer, onOpen, className = '', fallback = null }) => {
  const label = name || fallback;
  if (!label) return null;

  if (!id || !onOpen || !canViewUserPages(viewer)) {
    return <span className={className}>{label}</span>;
  }

  return (
    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); onOpen(id); }}
      className={`hover:underline text-left ${className}`}
      title={`View ${label}`}
    >
      {label}
    </button>
  );
};

export default UserLink;
